const HTTP = "http";
const BASE_URL = "190.223.56.109";
// const BASE_URL = "localhost";
const PORT_API_REAL_TIME = "5001";
// const PORT_API = "8080";
// const PORT_API = "443";
//const PORT_API = "5000";
const PORT_API = "3000";

const HOST_API_REAL_TIME = `${HTTP}://${BASE_URL}:${PORT_API_REAL_TIME}/`;
const HOST_API = `${HTTP}://${BASE_URL}:${PORT_API}`;

const DEV = 0;
const DEV_URL = "http://localhost:5000";

const FORM_DEV_VIEW = 0;

const CONSOLE = false;

export { HTTP, BASE_URL, PORT_API_REAL_TIME, PORT_API, HOST_API_REAL_TIME, HOST_API, DEV, FORM_DEV_VIEW, DEV_URL, CONSOLE };
